import { useCallback, useEffect, useState } from 'react';
import Checkbox from 'src/components/atoms/checkbox/checkbox';
import Modal from 'src/components/atoms/modal/modal';
import { Capability, Role } from 'src/models/user.model';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { getCapabilities } from 'src/reducers/capability.reducer';
import styles from '../profiles-and-authorizations.module.scss';
import { changeCapabilitiesForRole } from 'src/reducers/changeCapabilityForRole.reducer';
import Spinner from 'src/components/atoms/spinner/spinner';
import { groupCapabilities } from 'src/utils/capability-utils';

type Props = {
  role: Role;
  capabilitiesRole: Capability[];
};

export const ProfilesAndAuthorizationsDetails = (props: Props) => {
  const { role, capabilitiesRole } = props;
  const dispatch = useAppDispatch();
  const [checkedCapabilityIds, setCheckedCapabilityIds] = useState<number[]>([]);

  const capabilityReducer = useAppSelector(state => state.capability);

  useEffect(() => {
    dispatch(getCapabilities());
  }, [dispatch]);

  useEffect(() => {
    if (capabilitiesRole && capabilitiesRole.length > 0) {
      const initialCheckedCapabilityIds = capabilitiesRole.map(capability => capability.id);
      setCheckedCapabilityIds(initialCheckedCapabilityIds);
    }
  }, [capabilitiesRole]);

  const handleCheckCapability = useCallback(
    (capabilityId: number) => {
      if (checkedCapabilityIds.includes(capabilityId)) {
        const updatedCheckedCapabilityIds = checkedCapabilityIds.filter(id => id !== capabilityId);
        setCheckedCapabilityIds(updatedCheckedCapabilityIds);
      } else {
        const updatedCheckedCapabilityIds = [...checkedCapabilityIds, capabilityId];
        setCheckedCapabilityIds(updatedCheckedCapabilityIds);
      }
      dispatch(
        changeCapabilitiesForRole({
          roleId: role.id,
          capabilityId,
        })
      );
    },
    [checkedCapabilityIds, dispatch, role.id]
  );

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <div className={styles.profileDetailsBody}>
          <div className={styles.capabilities}>
            <>
              {capabilityReducer.fetchLoading && <Spinner className={styles.spinner} />}
              {!capabilityReducer.fetchLoading &&
                capabilityReducer.fetchSuccess &&
                capabilityReducer.capabilities?.length === 0 &&
                'Non sono state trovate autorizzazioni.'}
              {!capabilityReducer.fetchLoading && capabilityReducer.fetchFailure && 'Errore durante il caricamento delle autorizzazioni.'}
            </>
            {!capabilityReducer.fetchLoading &&
              capabilityReducer.fetchSuccess &&
              capabilityReducer.capabilities?.length > 0 &&
              Object.entries(groupCapabilities(capabilityReducer.capabilities)).map(([groupName, capabilities]) => (
                <div key={groupName} className={styles.capabilityGroup}>
                  <div className={styles.groupName}>{groupName}</div>
                  {capabilities.map(capability => (
                    <div className={styles.capabilityForRoleCard} key={capability.id}>
                      <Checkbox
                        checked={checkedCapabilityIds.includes(capability.id)}
                        onCheck={() => handleCheckCapability(capability.id)}
                      />
                      <div>{capability.name}</div>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
      </Modal.Body>
    </>
  );
};
